/* 11.10.2026: ürün kartı renk noktaları (snippets/atlanticus-card-swatches.liquid).
   Noktanın üzerine gelince kart görseli o rengin görseline geçer; karttan çıkınca ilk görsele döner. */
(function () {
  function imgs(card) { return card ? card.querySelectorAll('.card__media img') : []; }
  function restore(card) {
    if (card._atlSwiped) return; // dokunmatikte kaydırarak seçilen renk kalır (bağlantılar da o renkte)
    imgs(card).forEach(function (im) {
      if (im.dataset.atlSrc) { im.src = im.dataset.atlSrc; im.srcset = im.dataset.atlSrcset || ''; delete im.dataset.atlSrc; delete im.dataset.atlSrcset; }
    });
    var dots = card.querySelectorAll('.atl-sw__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === 0); });
  }
  // 14.10.2026 kullanıcı ("geçişlerde yavaşlık var"): kartın üzerine gelinince renk görselleri önceden yüklenir → kutucukta anında geçiş
  function preload(card) {
    if (!card || card.dataset.atlPre) return;
    card.dataset.atlPre = '1';
    card.querySelectorAll('.atl-sw__dot[data-img]').forEach(function (d) { var im = new Image(); im.decoding = 'async'; im.src = d.getAttribute('data-img'); });
  }
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && (e.target.closest('.card-wrapper') || e.target.closest('.product-card-wrapper'));
    if (c) preload(c);
    var d = e.target.closest && e.target.closest('.atl-sw__dot');
    if (!d) return;
    var card = d.closest('.card-wrapper') || d.closest('.product-card-wrapper');
    if (!card) return;
    card.querySelectorAll('.atl-sw__dot').forEach(function (x) { x.classList.toggle('is-on', x === d); });
    var src = d.getAttribute('data-img');
    if (!src) return;
    imgs(card).forEach(function (im) {
      if (!im.dataset.atlSrc) { im.dataset.atlSrc = im.src; im.dataset.atlSrcset = im.getAttribute('srcset') || ''; }
      im.srcset = ''; im.src = src;
    });
  });
  // 20.10.2026 kullanıcı ("mobilde renk seçimi tıklaması zor"): dokunmatikte kart görselinde parmakla sola/sağa kaydırınca sıradaki/önceki
  // renk — görsel, kutucuk ve karttaki bağlantılar o renge geçer (basınca ürün o renkle açılır). Yatay kayan şeritlerdeki kartlarda çalışmaz.
  function cardOf(el) { return el && el.closest && (el.closest('.card-wrapper') || el.closest('.product-card-wrapper')); }
  function inHScroller(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var ox = getComputedStyle(p).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 4) return true;
    }
    return false;
  }
  function showDot(card, d) {
    card.querySelectorAll('.atl-sw__dot').forEach(function (x) { x.classList.toggle('is-on', x === d); });
    var src = d.getAttribute('data-img');
    if (src) imgs(card).forEach(function (im) { im.srcset = ''; im.src = src; });
    var href = d.getAttribute('href');
    if (href) card.querySelectorAll('a[href*="/products/"]:not(.atl-sw__dot)').forEach(function (a) { a.setAttribute('href', href); });
  }
  // tarayıcı yatay hareketi kendine almasın: renkli ve yatay şeritte olmayan kartlarda yalnız dikey kaydırma tarayıcıya kalır
  function panY() {
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach(function (c) {
      if (c.dataset.atlPan || !c.querySelector('.atl-sw__dot[data-img]')) return;
      c.dataset.atlPan = '1';
      if (!inHScroller(c)) c.style.touchAction = 'pan-y';
    });
  }
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', panY); else panY();
    window.addEventListener('load', panY);
  }
  var tx = null;
  document.addEventListener('touchcancel', function () { tx = null; }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    tx = null;
    // görselin üstünü kartın tam boy bağlantısı (a.full-unstyled-link ::after) kaplıyor → dokunulan nokta görselin alanında mı, ona bakılır
    var card = cardOf(e.target);
    if (!card || e.touches.length !== 1 || !card.querySelector('.atl-sw__dot[data-img]') || inHScroller(card)) return;
    var m = card.querySelector('.card__media'), r = m && m.getBoundingClientRect(), p0 = e.touches[0];
    if (!r || p0.clientX < r.left || p0.clientX > r.right || p0.clientY < r.top || p0.clientY > r.bottom) return;
    preload(card);
    tx = { x: e.touches[0].clientX, y: e.touches[0].clientY, card: card };
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!tx) return;
    var t = e.changedTouches[0], dx = t.clientX - tx.x, dy = t.clientY - tx.y, card = tx.card;
    tx = null;
    if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var dots = Array.prototype.slice.call(card.querySelectorAll('.atl-sw__dot'));
    var cur = 0;
    dots.forEach(function (x, i) { if (x.classList.contains('is-on')) cur = i; });
    showDot(card, dots[(cur + (dx < 0 ? 1 : -1) + dots.length) % dots.length]);
    card._atlSwiped = Date.now();
  }, { passive: true });
  // kaydırmanın ardından gelen tıklama ürüne gitmesin
  document.addEventListener('click', function (e) {
    var card = cardOf(e.target);
    if (card && card._atlSwiped && Date.now() - card._atlSwiped < 450) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && (e.target.closest('.card-wrapper') || e.target.closest('.product-card-wrapper'));
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    restore(card);
  });
})();
